const isLocalhost = window.location.hostname === 'localhost'

export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'https://dev-simonai-cms.coke.com'
export const SERVER_PREFIX = process.env.REACT_APP_SERVER_PREFIX || ''
export const API_PREFIX = process.env.REACT_APP_API_PREFIX || '/api'
export const PRIVATE_PREFIX = process.env.REACT_APP_API_PREFIX || '/private'


// process.env.REACT_APP_SERVER_URL ||
// (isLocalhost ? 'http://localhost:8080' : window.location.protocol + '//' + window.location.hostname)

export const WIDGET_BASE_URL = isLocalhost ? 'http://localhost:3030' : SERVER_URL + '/widget'

export const EMBEDDED_AI_CHAT_BASE_URL = isLocalhost
  ? 'http://localhost:3031'
  : 'https://bep-embedded-ai-chat.vercel.app'

// Url of backend on a server (server url + nginx prefix for requests to tomcat)
export const BACKEND_URL = SERVER_URL + (SERVER_PREFIX + API_PREFIX).replace('//', '/')
export const BASE_URL = SERVER_URL + (SERVER_PREFIX + API_PREFIX + PRIVATE_PREFIX).replace('//', '/')

console.log(BACKEND_URL)
console.log(BASE_URL)

export const HOME_PATH = process.env.REACT_APP_HOME_PATH || '/admin'

export const USE_MESSAGE_KEYS = process.env.REACT_APP_USE_MESSAGE_KEYS !== '0'
